import { Listing, SubscriptionType, Feature, ListingBySlugQuery } from '@gql';

// Union of all listingBySlug types
type ListingBySlugQueryResults = NonNullable<
  ListingBySlugQuery['listingBySlug']
>;

// Get the branch of the listing union that has a specific typename
type ListingBySlugQueryResultsType<
  T extends ListingBySlugQueryResults['__typename'],
> = ListingBySlugQueryResults & { __typename: T };

export type ListingBySlugPartial = ListingBySlugQueryResultsType<'Listing'>;

export function generateMetaTitle(listing: {
  name: string;
  city: string;
  stateOrProvinceLongName: string;
  subscriptionType: SubscriptionType;
}): string {
  switch (listing.subscriptionType) {
    case SubscriptionType.Free:
      return `${listing.name}, ${listing.city}, ${listing.stateOrProvinceLongName} Vacation rentals Inns`;
    case SubscriptionType.Bronze:
      return `${listing.name}, ${listing.city}, ${listing.stateOrProvinceLongName} Vacation rentals Inns`;
    case SubscriptionType.Gold:
      return `Vacation rental Inn ${listing.city}, ${listing.stateOrProvinceLongName} ${listing.name}`;
    case SubscriptionType.Silver:
      return `${listing.city} ${listing.stateOrProvinceLongName} Vacation rental Inn ${listing.name}`;
    default:
      return `${listing.name}, ${listing.city}, ${listing.stateOrProvinceLongName} Vacation rentals Inns`;
  }
}

export function generateMetaDescription(listing: {
  name: string;
  city: string;
  stateOrProvinceLongName: string;
  subscriptionType: SubscriptionType;
}): string {
  switch (listing.subscriptionType) {
    case SubscriptionType.Free:
      return `Find your ${listing.stateOrProvinceLongName} VR getaway at ${listing.name}. Best Vacation rental in ${listing.city}, ${listing.stateOrProvinceLongName}. View Photos and Links`;
    case SubscriptionType.Private:
      return `Find your ${listing.stateOrProvinceLongName} VR getaway at ${listing.name}. Best Vacation rental in ${listing.city}, ${listing.stateOrProvinceLongName}. View Photos and Links`;
    case SubscriptionType.Bronze:
      return `Find your ${listing.stateOrProvinceLongName} VR getaway at ${listing.name}. Best Vacation rental in ${listing.city}, ${listing.stateOrProvinceLongName}. View Photos and Links`;
    case SubscriptionType.Silver:
      return `Searching for a hotel in ${listing.city}, ${listing.stateOrProvinceLongName}? Get better service and value with a Vacation rental ${listing.name}, ${listing.city}, {State Full Name}`;
    case SubscriptionType.Gold:
      return `Visit ${listing.name} in ${listing.city}, ${listing.stateOrProvinceLongName}. Best ${listing.stateOrProvinceLongName} Vacation rental Directory to find VR's online in ${listing.stateOrProvinceLongName}.`;
    default:
      throw new Error('Invalid subscription type');
  }
}

export function filterSafetyFeatures(
  listing: Pick<Listing, 'features'>
): Feature[] {
  if (!listing.features) {
    return [];
  }

  return listing.features.filter(
    (feature) => feature.categoryName === 'Safety Measures'
  );
}

export function filterPopularFeatures(
  listing: Pick<Listing, 'features'>
): Feature[] {
  if (!listing.features) {
    return [];
  }

  return listing.features.filter(
    (feature) => feature.promoted && feature.categoryName !== 'Safety Measures'
  );
}
